import { Button } from './ui/button';
import { ArrowUp } from 'lucide-react';

export const FinalCTA = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="py-20 bg-gradient-to-br from-blue-900 via-slate-900 to-blue-900 text-white relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-72 h-72 bg-yellow-400 opacity-10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-blue-400 opacity-10 rounded-full blur-3xl"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl mx-auto text-center space-y-8">
          <h2 className="text-4xl md:text-5xl font-bold">
            Start Your <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-300 to-yellow-500">Home Buying</span> Journey Today
          </h2>
          
          <p className="text-xl text-blue-100 leading-relaxed">
            Join us on December 17th and discover how to turn your dream of homeownership into reality.
          </p>

          <div className="pt-4">
            <Button
              onClick={scrollToTop}
              className="bg-gradient-to-r from-yellow-500 to-yellow-600 hover:from-yellow-600 hover:to-yellow-700 text-white font-bold py-6 px-12 text-lg shadow-2xl transition-all duration-300 hover:shadow-yellow-500/20 hover:scale-[1.05] inline-flex items-center gap-2"
            >
              <ArrowUp className="w-5 h-5" />
              Register Now
            </Button>
          </div>

          <div className="pt-12">
            <img
              src="https://images.unsplash.com/photo-1582407947304-fd86f028f716?w=1200&q=80"
              alt="Your Dream Home Awaits"
              className="rounded-lg shadow-2xl mx-auto"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
